import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import QueueSelect from "../QueueSelect";
import PromptSelect from "../PromptSelect";
import IntegrationSelect from "../IntegrationSelect";

/**
 * Seccion de automatizacion de la conexion: Departamento / Prompt / FlowBuilder / Integracion.
 * Selects mutuamente exclusivos (solo uno activo). Estado gestionado por el modal padre.
 */
const AutomationSection = ({
  classes,
  selectedQueueId,
  handleChangeQueue,
  selectedPrompt,
  handleChangePrompt,
  selectedIntegration,
  handleChangeIntegration,
  selectedFlowBuilder,
  setSelectedFlowBuilder,
  setSelectedPrompt,
  setSelectedIntegration,
  setSelectedQueueId,
  loadingFlowBuilders,
  flowBuilders,
  hasPromptInForm,
  hasIntegrationInForm,
  hasFlowBuilderInForm,
  hasQueueInForm,
}) => {
  return (
    <>
                      {/* Departamento (full width) - Compacto */}
                      <Grid item xs={12}>
                        <div className={classes.compactSelectWrapper} style={{ opacity: (hasPromptInForm || hasIntegrationInForm || hasFlowBuilderInForm) ? 0.5 : 1, pointerEvents: (hasPromptInForm || hasIntegrationInForm || hasFlowBuilderInForm) ? 'none' : 'auto' }}>
                          <QueueSelect
                            selectedQueueIds={selectedQueueId}
                            onChange={(selectedId) => handleChangeQueue(selectedId)}
                            multiple={false}
                            title={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="departamento">🏢</span> Departamento (Opcional)</span>}
                          />
                        </div>
                      </Grid>
                      
                      {/* Prompt + FlowBuilder en la misma fila - Compactos */}
                      <Grid item xs={12} sm={6}>
                        <div className={classes.compactSelectWrapper}>
                          <PromptSelect
                            selectedPromptId={selectedPrompt}
                            onChange={handleChangePrompt}
                            disabled={hasIntegrationInForm || hasFlowBuilderInForm}
                            title={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="prompt">🤖</span> {i18n.t("whatsappModal.form.prompt")} (Opcional)</span>}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          className={classes.formControlCompact}
                        >
                          <InputLabel id="flowBuilderId-selection-label" style={{ fontSize: '0.875rem' }}>
                            Flowbuilder (Opcional)
                          </InputLabel>
                          <Select
                            label="Flowbuilder (Opcional)"
                            name="flowBuilderId"
                            id="flowBuilderId"
                            labelId="flowBuilderId-selection-label"
                            value={selectedFlowBuilder || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              setSelectedFlowBuilder(value);
                              // ✅ Si se selecciona FlowBuilder, limpiar otros campos
                              if (value && value !== "") {
                                setSelectedPrompt('');
                                setSelectedIntegration('');
                                setSelectedQueueId('');
                              }
                            }}
                            disabled={loadingFlowBuilders || hasPromptInForm || hasIntegrationInForm || hasQueueInForm}
                            style={{ fontSize: '0.875rem', height: '40px' }}
                            MenuProps={{
                              PaperProps: {
                                style: { maxHeight: 300 }
                              }
                            }}
                          >
                            <MenuItem value="" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Sin flujo</MenuItem>
                            {flowBuilders.map((flow) => (
                              <MenuItem key={flow.id} value={flow.id} style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>
                                {flow.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      
                      {/* Integración (full width) - Compacto */}
                      <Grid item xs={12}>
                        <div className={classes.compactSelectWrapper}>
                          <IntegrationSelect
                            selectedIntegrationId={selectedIntegration}
                            onChange={handleChangeIntegration}
                            title={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="integración">🔗</span> Integración (Opcional)</span>}
                          />
                        </div>
                      </Grid>
    </>
  );
};

export default AutomationSection;
